// extracted by mini-css-extract-plugin
export default {"backToTopBtn":"BackToTop_backToTopBtn__VYevO","show":"BackToTop_show__JKMyo"};